module.exports = __webpack_public_path__ + "img/materials_analysis_3.c78fe8c3.png";